module.exports = __webpack_public_path__ + "static/media/about-chat.ed0f795e.svg";